import { Anchor, Box, Breadcrumbs, Container, Stack, Text, Title } from '@mantine/core'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/legal/terms')({
  component: TermsPage,
})

function TermsPage() {
  return (
    <Box style={{ minHeight: '100vh' }}>
      <Container size="md" py="xl">
        <Breadcrumbs mb="lg">
          <Anchor component={Link} to="/" c="dimmed">
            Home
          </Anchor>
          <span>Syarat & Ketentuan</span>
        </Breadcrumbs>
        <Stack gap="md">
          <Title order={1}>Syarat & Ketentuan</Title>
          <Text c="dimmed" size="sm">
            Efektif: 1 Januari 2026
          </Text>
          <Text>
            Dokumen ini mengatur penggunaan layanan JP MARINE. Dengan menggunakan layanan kami, Anda setuju dengan
            syarat-syarat di bawah ini.
          </Text>
          <Title order={3}>1. Penerimaan Syarat</Title>
          <Text>
            Dengan mendaftar atau menggunakan JP MARINE, Anda menyetujui syarat dan ketentuan ini secara keseluruhan.
            Jika tidak setuju, harap tidak menggunakan layanan.
          </Text>
          <Title order={3}>2. Paket Berlangganan</Title>
          <Text>
            JP MARINE menyediakan paket Starter, Professional, dan Enterprise dengan fitur dan harga yang tertera di
            halaman Harga. Biaya ditagih bulanan (atau tahunan) di muka.
          </Text>
          <Title order={3}>3. Free Trial</Title>
          <Text>
            Pengguna baru mendapat 30 hari trial gratis tanpa kartu kredit. Setelah trial, Anda dapat memilih
            berlangganan atau menghentikan akun.
          </Text>
          <Title order={3}>4. Data Pelanggan</Title>
          <Text>
            Data yang Anda input tetap menjadi milik Anda. JP MARINE hanya memproses untuk menyediakan layanan. Lihat
            Kebijakan Privasi untuk detail.
          </Text>
          <Title order={3}>5. Pembatalan</Title>
          <Text>
            Anda dapat membatalkan kapan saja. Data tetap dapat diakses hingga periode berlangganan berakhir. Export
            data tersedia.
          </Text>
          <Title order={3}>6. Kontak</Title>
          <Text>
            Pertanyaan seputar ToS: <Anchor href="mailto:legal@open-marina.id">legal@open-marina.id</Anchor>
          </Text>
          <Text c="dimmed" size="xs" mt="xl">
            Dokumen placeholder. Draft final akan dipublikasikan setelah review legal.
          </Text>
        </Stack>
      </Container>
    </Box>
  )
}
